import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, Transition as _Transition, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "component-contents" }
const _hoisted_2 = { class: "message-part" }
const _hoisted_3 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_4 = {
  key: 1,
  class: "help is-danger"
}
const _hoisted_5 = { class: "response-part" }
const _hoisted_6 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_7 = {
  key: 1,
  class: "help is-danger"
}
const _hoisted_8 = {
  key: 2,
  class: "help is-danger"
}

import { InputVariableViewModel, StateViewModel } from '@/features/bots/models/designer';
import VariablePicker from './VariablePicker/VariablePicker.vue';
import IslandBadge from './IslandBadge.vue';
import AdditionalInformationWrapper from './AdditionalInformationWrapper.vue';
import InputValidationConfig from './InputValidationConfig.vue';
import { required } from '@vuelidate/validators';
import ChevronRight from 'vue-material-design-icons/ChevronDoubleRight.vue';
import ChevronLeft from 'vue-material-design-icons/ChevronDoubleLeft.vue';
import ErrorIcon from 'vue-material-design-icons/AlertCircleOutline.vue';
import TextEditor from '@/features/bots/components/designer/TextEditor/TextEditor.vue';
import { TransitionType } from '@/features/bots/models/designer/transitionType';
import { RegexType } from '../../models/designer/regexType';
import { computed, nextTick, onMounted, PropType, ref, watch } from 'vue';
import { useStore } from 'vuex';
import useVuelidate from '@vuelidate/core';
import VuelidateUtil from '@shared/util/vuelidateUtil';


export default /*@__PURE__*/_defineComponent({
  __name: 'InputStringComponent',
  props: {
  value: {
    type: Object as PropType<StateViewModel>,
    required: true,
  },
},
  emits: ["state-updated"],
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

__expose({
  focusOnInput,
});

const store = useStore();
const doesAttributeExist = (attributeId: string) => computed(() => store.getters.doesAttributeExist(attributeId));
const isAttributeArchived = (attributeId: string) => computed(() => store.getters.isAttributeArchived(attributeId));
const textEditor = ref<typeof TextEditor | null>(null);

const showConfig = ref(false);
const hasClicked = ref(false);
const transition = ref('display');
const invalidAttribute = ref(false);
const state = ref<StateViewModel>({
  id: '',
  component: 'InputString',
});
const visibleFields = ref<string[]>([]);
const selectedVariable = ref('');
const additionalConfigInvalid = ref(false);

const validations = {
  state: {
    text: {
      required,
      attributeInvalid(text: string) {
        return !invalidAttribute.value;
      },
    },
  },
  selectedVariable: {
    required,
    attributeMissing(value: string) {
      const storedVar = state.value.storedVariable;
      return !storedVar || storedVar.scope !== 'appUser.customAttributes' || doesAttributeExist(storedVar.key);
    },
    attributeArchived(value: string) {
      return !isArchived();
    },
  },
};

const $v = useVuelidate(validations, { state, selectedVariable });
const isTextRequiredInvalid = computed(() => VuelidateUtil.isRequiredInvalid($v, (v) => v.state.text));
const isTextAttributeInvalid = computed(() =>
  VuelidateUtil.isValidationInvalid($v, (v) => v.state.text, 'attributeInvalid'),
);
const isVariableRequiredInvalid = computed(() => VuelidateUtil.isRequiredInvalid($v, 'selectedVariable'));
const isAttributeMissingInvalid = computed(() =>
  VuelidateUtil.isValidationInvalid($v, 'selectedVariable', 'attributeMissing'),
);
const isAttributeArchivedInvalid = computed(() =>
  VuelidateUtil.isValidationInvalid($v, 'selectedVariable', 'attributeArchived'),
);

watch(
  () => props.value,
  (value: StateViewModel) => {
    try {
      state.value = value;
      if (state.value.storedVariable) {
        selectedVariable.value = state.value.storedVariable.id;
      }
      updateValidation();
    } catch (err: any) {
      console.error('watch(() => props.value', err);
    }
  },
  { immediate: true },
);

onMounted(() => initialiseVisibleFields());

function setClickedState() {
  hasClicked.value = true;
}

function setUnclickedState() {
  hasClicked.value = false;
  showConfig.value = false;
  transition.value = 'display';

  $v.value.$touch();
}

function showExpandedConfig() {
  hasClicked.value = true;
  showConfig.value = true;
  transition.value = 'none';
}

function hideExpandedConfig() {
  showConfig.value = false;
}

function textUpdated(text: string) {
  if (state.value.text === text) {
    return;
  }

  state.value.text = text;

  updateValidation();
  if ($v.value.state && $v.value.state.text) {
    $v.value.state.text.$touch();
  }

  emit('state-updated', state.value);
}

function initialiseVisibleFields() {
  if (isAppUserName()) {
    visibleFields.value = [];
  } else if (isAppUserEmail()) {
    visibleFields.value = ['errorMessage', 'allowedAttempts', 'noMatch'];
  } else if (isAppUserPhoneNumber()) {
    visibleFields.value = ['errorMessage', 'allowedAttempts', 'noMatch'];
  } else {
    visibleFields.value = ['errorMessage', 'pattern', 'allowedAttempts', 'noMatch'];
  }
}

function variableSelected(variable: InputVariableViewModel) {
  selectedVariable.value = variable.id;
  state.value.storedVariable = variable;

  if (isAppUserName()) {
    state.value.pattern = '';
    state.value.allowedAttempts = -1;
    state.value.errorMessage = '';
    state.value.noMatch = { type: TransitionType.Path, payload: '' };
    additionalConfigInvalid.value = false;
  } else if (isAppUserEmail()) {
    state.value.pattern = RegexType.EMAIL;
    state.value.allowedAttempts = -1;
    state.value.errorMessage =
      state.value.errorMessage && state.value.errorMessage.length
        ? state.value.errorMessage
        : "That's not a valid email address, please try again.";
    state.value.noMatch = { type: TransitionType.Path, payload: '' };
    additionalConfigInvalid.value = false;
  } else if (isAppUserPhoneNumber()) {
    state.value.pattern = RegexType.PHONE_NUMBER;
    state.value.allowedAttempts = -1;
    state.value.errorMessage =
      state.value.errorMessage && state.value.errorMessage.length
        ? state.value.errorMessage
        : "That's not a valid phone number, please try again.";
    state.value.noMatch = { type: TransitionType.Path, payload: '' };
    additionalConfigInvalid.value = false;
  } else if (state.value.storedVariable.dataType === 'number') {
    state.value.pattern = RegexType.NUMERIC;
    state.value.allowedAttempts = -1;
    state.value.errorMessage =
      state.value.errorMessage && state.value.errorMessage.length
        ? state.value.errorMessage
        : "That's not a valid number, please try again.";
    state.value.noMatch = { type: TransitionType.Path, payload: '' };
    additionalConfigInvalid.value = false;
  } else if (state.value.storedVariable.dataType === 'decimal') {
    state.value.pattern = RegexType.DECIMAL;
    state.value.allowedAttempts = -1;
    state.value.errorMessage =
      state.value.errorMessage && state.value.errorMessage.length
        ? state.value.errorMessage
        : "That's not a valid decimal, please try again.";
    state.value.noMatch = { type: TransitionType.Path, payload: '' };
    additionalConfigInvalid.value = false;
  } else {
    state.value.pattern = '';
    state.value.allowedAttempts = -1;
    state.value.errorMessage =
      state.value.errorMessage && state.value.errorMessage.length ? state.value.errorMessage : '';
    state.value.noMatch =
      state.value.noMatch && state.value.noMatch.payload
        ? state.value.noMatch
        : { type: TransitionType.Path, payload: '' };
  }

  initialiseVisibleFields();
  if ($v.value.state && $v.value.state.storedVariable) {
    $v.value.state.storedVariable.$touch();
  }
  updateValidation();

  emit('state-updated', state.value);
}

function additionalConfigChanged(newState: StateViewModel, invalid: boolean) {
  state.value = newState;
  additionalConfigInvalid.value = invalid;
  updateValidation();
  emit('state-updated', state.value);
}

function isArchived(): boolean {
  if (state.value && state.value.storedVariable) {
    return isAttributeArchived(state.value.storedVariable!.key).value;
  }
  return false;
}

function setInvalidAttribute(val: boolean) {
  invalidAttribute.value = val;
  $v.value.$touch();
  state.value.invalid = $v.value.$invalid;
}

function focusOnInput() {
  textEditor.value?.focusElement();
  textEditor.value?.startEditing();
}

function isAppUserName() {
  return (
    state.value.storedVariable &&
    state.value.storedVariable.scope === 'appUser' &&
    state.value.storedVariable.key === 'name'
  );
}

function isAppUserEmail() {
  return (
    state.value.storedVariable &&
    state.value.storedVariable.scope === 'appUser' &&
    state.value.storedVariable.key === 'email'
  );
}

function isAppUserPhoneNumber() {
  return (
    state.value.storedVariable &&
    state.value.storedVariable.scope === 'appUser' &&
    state.value.storedVariable.key === 'phoneNumber'
  );
}

async function updateValidation() {
  if (!state.value) return;
  await nextTick(); // Needed so variable picker if opened unmounts otherwise we will pickup the validation
  state.value.invalid = additionalConfigInvalid.value || $v.value.$invalid;
}

return (_ctx: any,_cache: any) => {
  const _directive_click_away = _resolveDirective("click-away")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: "inputstring-component",
    onClick: setClickedState
  }, [
    _createVNode(IslandBadge, { type: "inputstring" }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(TextEditor, {
          ref_key: "textEditor",
          ref: textEditor,
          value: state.value.text,
          placeholder: 'Enter a question...',
          onTextUpdated: textUpdated,
          onError: setInvalidAttribute
        }, null, 8, ["value"]),
        (isTextRequiredInvalid.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, "Message text must not be empty"))
          : _createCommentVNode("", true),
        (isTextAttributeInvalid.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, "Message contains an invalid attribute"))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(VariablePicker, {
          value: state.value.storedVariable,
          onVariableSelected: variableSelected
        }, null, 8, ["value"]),
        (isVariableRequiredInvalid.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_6, "Must store result in a variable"))
          : _createCommentVNode("", true),
        (isAttributeMissingInvalid.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_7, "Attribute does not exist"))
          : _createCommentVNode("", true),
        (isAttributeArchivedInvalid.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_8, "Attribute has been archived"))
          : _createCommentVNode("", true)
      ])
    ]),
    (showConfig.value && visibleFields.value.length)
      ? (_openBlock(), _createBlock(AdditionalInformationWrapper, {
          key: 0,
          color: "#FF6666",
          "text-color": "#FFFFFF"
        }, {
          content: _withCtx(() => [
            _createVNode(InputValidationConfig, {
              value: state.value,
              fields: visibleFields.value,
              onUpdated: additionalConfigChanged
            }, null, 8, ["value", "fields"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_Transition, { name: transition.value }, {
      default: _withCtx(() => [
        (hasClicked.value && !showConfig.value && visibleFields.value.length)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "expander",
              onClick: showExpandedConfig
            }, [
              _createVNode(ChevronRight, { class: "chevron" })
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["name"]),
    (hasClicked.value && showConfig.value && visibleFields.value.length)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "expander",
          onClick: hideExpandedConfig
        }, [
          _createVNode(ChevronLeft, { class: "chevron" })
        ]))
      : _createCommentVNode("", true),
    (state.value.invalid && !showConfig.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: _normalizeClass(["invalid-warning", { 'shift-for-expander': hasClicked.value && visibleFields.value.length }])
        }, [
          _createVNode(ErrorIcon, { class: "icon-1-3x" })
        ], 2))
      : _createCommentVNode("", true)
  ])), [
    [_directive_click_away, setUnclickedState]
  ])
}
}

})